import { render, staticRenderFns } from "./jfzc.vue?vue&type=template&id=915794fa&"
import script from "./jfzc.vue?vue&type=script&lang=js&"
export * from "./jfzc.vue?vue&type=script&lang=js&"
import style0 from "./jfzc.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports